/**
 * OptimierungDoneRow — übernommenes Feld als kollabierte grüne Bestätigungszeile
 * mit Channel-Tag, Snippet und Rückgängig (~5s). Kein Modal, kein Reload.
 */
import { Check, CornerUpLeft } from 'lucide-react'

import { DV2 } from './tokens'
import { attrLabel } from './labels'

export interface OptimierungDoneRowProps {
  attributeCode: string
  channelName: string
  snippet: string
  meta?: string
  onUndo?: () => void
}

export function OptimierungDoneRow({
  attributeCode,
  channelName,
  snippet,
  meta,
  onUndo,
}: OptimierungDoneRowProps) {
  return (
    <div className={`rounded-xl border ${DV2.addBd} ${DV2.addBg} overflow-hidden`}>
      <div className="flex items-center gap-3 px-3.5 py-2.5">
        <span className={`flex h-6 w-6 items-center justify-center rounded-full ${DV2.addRail} text-black`}>
          <Check size={14} />
        </span>
        <div className="min-w-0 flex-1">
          <div className={`text-sm-minus font-semibold ${DV2.fg1}`}>{attrLabel(attributeCode)}</div>
          <div className={`text-xs-plus ${DV2.fg3}`}>
            An <span className={DV2.addFg}>{channelName}</span> übernommen
          </div>
        </div>
        {meta && <span className={`font-mono text-2xs ${DV2.fg4}`}>{meta}</span>}
        {onUndo && (
          <button type="button" onClick={onUndo} className={`flex items-center gap-1 rounded-md px-2 py-1 text-xs-plus ${DV2.fg3} hover:${DV2.fg1}`}>
            <CornerUpLeft size={11} />
            Rückgängig
          </button>
        )}
      </div>
      <div className={`flex items-start gap-2 border-t ${DV2.addBd} px-3.5 py-2 text-xs-plus ${DV2.fg3}`}>
        <span className={DV2.addFg}>→</span>
        <span className="line-clamp-2">{snippet}</span>
      </div>
    </div>
  )
}
